import { hideScroll, restoreScroll } from './_helpers.js'

if (checkIfExists('.shopping-cart')) {

const overlay = document.querySelector('.overlay')
const shoppingCart = document.querySelector('.shopping-cart')
const cartBtn = document.querySelector('.cart-btn')
const cartCloseBtn = document.querySelector('.cart-close-btn')

cartBtn.addEventListener('click', function(e) {
    e.preventDefault()

    overlay.classList.add('show-overlay')
    shoppingCart.classList.add('open-cart')
    hideScroll()
})

overlay.addEventListener('click', function(e) {
    shoppingCart.classList.remove('open-cart')
    overlay.classList.remove('show-overlay')
    restoreScroll()
})

$(document).on('click', '.cart-close-btn', function(e){
  e.preventDefault()
  shoppingCart.classList.remove('open-cart')
  overlay.classList.remove('show-overlay')
  restoreScroll()
})

// Направих го с jquery с $(document), за да може да рабори бутона като заредя продукти с ajax
// cartCloseBtn.addEventListener('click', function(e) {
//     e.preventDefault()
//     shoppingCart.classList.remove('open-cart')
//     overlay.classList.remove('show-overlay')
//     restoreScroll()
// })


}


$(document).on("click", ".cart-item-delete", function(e){
  e.preventDefault()
  var token = $("input[name=cart_token]").val()

  $.ajax({
    url: $(this).attr('href'),
    data: {"_token": token},
    dataType: "json",
    type: "delete",
    success: function(data){
      $("#cart-count").html(data.cart_count)
      $("#cart-count-mobile").html(data.cart_count)
      $("#cart-sum").html(data.cart_sum)
      $(".shopping-cart").html(data.cart_view)
    }
  })
})
